import React, { useContext } from "react";
import { UserDataContext } from "store/UserContext.jsx";
import FormInput from "../Input";

const FormSection = ({
    section,
    defaultValues,
    handleSubmit,
    reset,
    handleChange,
    extraField,
    containerClass,
    disabled = false,
}) => {
    const [userData] = useContext(UserDataContext);
    const handleDefaultValue = (inputName) => {
        return (defaultValues && defaultValues[inputName]) || "";
    };

    return (
        <div className={`${containerClass || ""}`}>
            {section.label && <h6 className="title">{section.label}</h6>}
            {section.inputs.map((input, inputIndex) => {
                const isShow =
                    input.access?.length > 0
                        ? input.access?.includes(userData.role)
                        : true;
                return (
                    <React.Fragment key={inputIndex}>
                        {isShow && (
                            <FormInput
                                input={input}
                                inputIndex={inputIndex}
                                key={input.name}
                                reset={reset}
                                defaultValue={handleDefaultValue(input.name)}
                                disabled={
                                    disabled ||
                                    input.notAccess?.includes(userData.role)
                                }
                                handleChange={(data) => {
                                    handleChange(input.name, data);
                                    handleSubmit(input.name, data);
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
            {extraField ? extraField : null}
        </div>
    );
};

export default FormSection;
